import {Injectable, Type} from '@angular/core';
import {BehaviorSubject, combineLatest, distinctUntilChanged, map, Subject} from 'rxjs';
import {PanelLateralComponent, Size} from "./panel-lateral.component";
import {DeteccionCambiosService} from "../../../../infrastructure/services/deteccion-cambios.service";

@Injectable({
  providedIn: 'root'
})

export class PanelLateralService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  public isOpen$ = this.isOpenSubject.asObservable();
  private modeSubject = new BehaviorSubject<'modal' | 'citation'>('modal');
  public mode$ = this.modeSubject.asObservable();
  public isCitationOpen$ = combineLatest([this.isOpen$, this.mode$]).pipe(
    map(([isOpen, mode]) => isOpen && mode === 'citation'),
    distinctUntilChanged(),
  );

  private _loadComponent = new Subject<Type<any>>();
  public componentToLoad$ = this._loadComponent.asObservable();
  private panelLateralComponentRef!: PanelLateralComponent;
  private versionCarga = 0;

  constructor(private detectaUIService: DeteccionCambiosService) {
  }

  public setTitulo(titulo: string): void {
    this.panelLateralComponentRef.titulo = titulo;
    this.detectaUIService.setActualizaUI();
  }

  public setSize(size: Size): void {
    this.panelLateralComponentRef.size = size;
    this.detectaUIService.setActualizaUI();
  }

  public setPanelLateralComponentRef(ref: PanelLateralComponent): void {
    this.panelLateralComponentRef = ref;
    this.detectaUIService.setActualizaUI();
  }

  public open() {
    this.isOpenSubject.next(true);
    this.detectaUIService.setActualizaUI();
  }

  public close() {
    ++this.versionCarga;
    this.isOpenSubject.next(false);
    this.modeSubject.next('modal');
    this.panelLateralComponentRef?.clear();
    this.detectaUIService.setActualizaUI();
  }

  public toggle() {
    if (this.isOpenSubject.value) {
      this.close();
    } else {
      this.open();
    }
  }

  public loadComponent(component: Type<any>, mode: 'modal' | 'citation' = 'modal') {
    ++this.versionCarga;
    this.modeSubject.next(mode);
    this.detectaUIService.setActualizaUI();
    return this.panelLateralComponentRef.loadComponent(component);
  }

  public reservarCarga(): () => boolean {
    const version = ++this.versionCarga;
    return () => version === this.versionCarga;
  }
}
